export default "{\n    \"placeholderText\": \"Groupe / Installation\",\n    \"searchPlaceholderText\": \"Rechercher par nom de groupe ou d'installation\"\n}\n"